import AccessibilityUtilities from "./utilities/accessibility.js";
import urlParameterTrackingInit from "./utilities/url-parameter-tracking.ts";
import cardsInit from "./components/card.ts";
import newsFeedInit from "./components/news-feed.ts";
import accordionInit from "./components/accordion.ts";
import homeExplorerInit from "./components/home-explorer.ts";
import carouselInit from "./components/carousel.ts";
import siteHeaderInit from "./components/site-header.ts";
import videoEmbedInit from "./components/video-embed.ts";
import modalInit from "./components/modal.ts";
import subnavInit from "./components/subnav.ts";
import cookieBarInit from "./components/cookies.ts";
import tabsInit from "./components/tabs.ts";
import homeNewsReportsInit from "./components/home-news-reports.ts";
import homeHeroInit from "./components/home-hero.ts";
import homeCardCarouselInit from "./components/home-card-carousel.ts";
import breadcrumbsInit from "./components/breadcrumbs.ts";
import tableInit from "./components/table.ts";
import homeAnimationsInit from "./pages/home-animations.ts";

// Import the main CSS file for the application (keep this line here after other imports)
import "../css/index.css";

document.addEventListener("DOMContentLoaded", () => {
  AccessibilityUtilities.init();
  urlParameterTrackingInit();
  cardsInit();
  newsFeedInit();
  accordionInit();
  homeExplorerInit();
  carouselInit();
  modalInit();
  subnavInit();
  videoEmbedInit();
  siteHeaderInit();
  cookieBarInit();
  tabsInit();
  homeNewsReportsInit();
  homeHeroInit();
  breadcrumbsInit();
  homeCardCarouselInit();
  tableInit();
  homeAnimationsInit();
});
